import { render, staticRenderFns } from "./VodacomCompetitionPopup.vue?vue&type=template&id=ca0cbdda&scoped=true"
import script from "./VodacomCompetitionPopup.vue?vue&type=script&lang=js"
export * from "./VodacomCompetitionPopup.vue?vue&type=script&lang=js"
import style0 from "./VodacomCompetitionPopup.vue?vue&type=style&index=0&id=ca0cbdda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0cbdda",
  null
  
)

export default component.exports